export const Encuesta = {
  satisfaccion: {
    codigo: "SDTC-SATISFACCION",
    preguntas: [
      {
        idPregunta: 1
      },
      {
        idPregunta: 2
      }
    ]
  },
  abandono : {
    codigo: "SDTC-ABANDONO",
    preguntas: [
      {
        idPregunta: 3
      }
    ]
  }
}

export default Encuesta;